import React, { useState, useRef } from 'react';
import { ComposedChart, XAxis, YAxis, Tooltip, Legend, Line, Bar, Brush, ResponsiveContainer, CartesianGrid } from 'recharts';
import { Modal, Button, Form } from 'react-bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'; // Import jsPDF for PDF download
import { VendorScoreCardReducerAction, funVendorScoreCard } from '../../../../store/actions/createTicketManageFields';
import { useDispatch } from 'react-redux';
import swal from 'sweetalert';
import ExcelExport from './ExcelExport';
import PDFExport from './PDFExport';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div style={{position: "relative", zIndex: 20, backgroundColor: "white", margin: "10px", padding: "10px" }} className="custom-tooltip">
                <p className="label text-black" style={{fontSize: "16px"}}>{label}</p>
                            {payload.map((item, index) => {
                let percentage = '';
                let siteCount = payload.find(i => i.name === "Site Count")?.value; // Find the Site Count value
                
                if (item.name === "Issue" && siteCount) {
                    // Calculate percentage based on Site Count
                    percentage = ` (${((item.value / siteCount) * 100).toFixed(2)}%)`;
                }
                
                return (
                    <div key={index} className="tooltip-item d-flex flex-row">
                        <span className="bar-color" 
                            style={{ 
                                width: "20px", 
                                height: "20px", 
                                marginRight: "5px", 
                                backgroundColor: item.color, 
                                color: item.color 
                            }}>
                        </span>
                        <p className="text-black">{`${item.name}: ${item.value}${percentage}`}</p>
                    </div>
                );
            })}

            </div>
        );
    }
    return null;
};

const RechartLineChart = ({ extraFilter, filtering, toollabeling, table, emsg, xAxis, yAxis, lisData, colrenameList, dic_col, final_dta, nextUrl, backUrl, toollabel }) => {
    const data_l = final_dta;
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [selectedGraphs, setSelectedGraphs] = useState({});
    const chartRef = useRef(null);

    const handleClick = (data, index) => {
        if (data?.activeLabel) {
            if (nextUrl !== "") {
                dispatch(funVendorScoreCard([]));
                dispatch(VendorScoreCardReducerAction(`${nextUrl}${data?.activeLabel}${filtering !== "" ? filtering + "&" + extraFilter : "?" + extraFilter}`));
            } else {
                swal({
                    title: "info",
                    icon: "info",
                    text: emsg,
                    timer: 2000
                });
            }
        }
    };

    const handleDownloadAsPDF = () => {
        const input = document.getElementById('export-container'); // Capture the chart container
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            pdf.addImage(imgData, 'PNG', 10, 10, 190, 100); // Adjust as per your requirement
            pdf.save('chart.pdf'); // Save the PDF
        });
    };


    return (
        <>
            <br />
            {/* <div onClick={handleDownloadAsPDF} style={{ cursor: 'pointer', marginLeft: '20px' }}>
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2 2 2 0 0 0 2 2h12a2 2 0 0 0 2-2 2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2V4a2 2 0 0 0-2-2h-7Zm-6 9a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-1h.5a2.5 2.5 0 0 0 0-5H5Zm1.5 3H6v-1h.5a.5.5 0 0 1 0 1Zm4.5-3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1.376A2.626 2.626 0 0 0 15 15.375v-1.75A2.626 2.626 0 0 0 12.375 11H11Zm1 5v-3h.375a.626.626 0 0 1 .625.626v1.748a.625.625 0 0 1-.626.626H12Zm5-5a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1h1a1 1 0 1 0 0-2h-2Z" clip-rule="evenodd"/>
</svg>

</div> */}
            {backUrl !== "" && (
                <svg fill="#ffffff" onClick={() => {
                    if (backUrl !== "") {
                        dispatch(funVendorScoreCard([]));
                        dispatch(VendorScoreCardReducerAction(`${backUrl}${filtering !== "" ? filtering : ""}`));
                    } else {
                        swal({
                            title: "info",
                            icon: "info",
                            text: "Last Stage Of Data",
                            timer: 2000
                        });
                    }
                }} height="32px" width="32px">
                    <g><path d="M94.861,156.507c2.929,2.928,7.678,2.927,10.606,0c2.93-2.93,2.93-7.678-0.001-10.608l-28.82-28.819l83.457-0.008 c4.142-0.001,7.499-3.358,7.499-7.502c-0.001-4.142-3.358-7.498-7.5-7.498l-83.46,0.008l28.827-28.825 c2.929-2.929,2.929-7.679,0-10.607c-1.465-1.464-3.384-2.197-5.304-2.197c-1.919,0-3.838,0.733-5.303,2.196l-41.629,41.628 c-1.407,1.406-2.197,3.313-2.197,5.303c0.001,1.99,0.791,3.896,2.198,5.305L94.861,156.507z" /></g>
                </svg>
            )}

            <br />
            <ExcelExport table={table} />
            <PDFExport table={table} />
            {/* <div onClick={handleDownloadAsPDF} style={{ cursor: 'pointer', marginLeft: '20px' }}>
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2 2 2 0 0 0 2 2h12a2 2 0 0 0 2-2 2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2V4a2 2 0 0 0-2-2h-7Zm-6 9a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-1h.5a2.5 2.5 0 0 0 0-5H5Zm1.5 3H6v-1h.5a.5.5 0 0 1 0 1Zm4.5-3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1.376A2.626 2.626 0 0 0 15 15.375v-1.75A2.626 2.626 0 0 0 12.375 11H11Zm1 5v-3h.375a.626.626 0 0 1 .625.626v1.748a.625.625 0 0 1-.626.626H12Zm5-5a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1h1a1 1 0 1 0 0-2h-2Z" clip-rule="evenodd"/>
</svg>

</div> */}

            <br />

            <p style={{ color: "white", marginLeft:"16px", fontSize:"14px" }}>{toollabeling}</p>
            <p style={{ color: "white", marginLeft:"16px", fontSize:"14px" }}>{toollabel}</p>
            <br />


            <ResponsiveContainer width="100%" height={400} id="export-container" ref={chartRef}>
                <ComposedChart
                    onClick={handleClick}
                    data={data_l}
                    margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
                >
                    <CartesianGrid stroke="#fff" strokeDasharray="5 5" />
                    {xAxis.map(itw => <XAxis key={itw} tick={{ fontSize: "10px", fill: '#ffffff' }} dataKey={itw} />)}
                    <YAxis tick={{ fontSize: "10px", fill: '#ffffff' }} yAxisId="left" />
                    <YAxis tick={{ fontSize: "10px", fill: '#ffffff' }} yAxisId="right" orientation="right" />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend verticalAlign="top" wrapperStyle={{ fontSize: "10px", color: "#ffffff", lineHeight: '20px' }} />
                    <Brush dataKey="groupName" height={15} stroke="#FF5F00" />
                    {yAxis.map(itq => (
                        lisData[itq]["chartType"] === "bar"
                            ? <Bar key={itq} yAxisId={lisData[itq]["axixShow"]} dataKey={itq} stackId={lisData[itq]["stackId"]} fill={lisData[itq]["color"]} barSize={40} />
                            : <Line key={itq} yAxisId={lisData[itq]["axixShow"]} type="monotone" stackId={lisData[itq]["stackId"]} dataKey={itq} stroke={lisData[itq]["color"]} />
                    ))}
                </ComposedChart>
            </ResponsiveContainer>

            
        </>
    );
};

export default RechartLineChart;
